import React, { useRef, useEffect, useState, useCallback } from 'react';
import classnames from 'classnames';

import { Grid, GridContainer, Cell, Section } from '../atoms/Grid';

import { Header } from 'formlabs-web-components/Type';

import useObserver from '../../hooks/useObserver';

import './CtaStickyNav.module.css';

const CtaStickyNav = ({ name, children }) => {
  const navRef = useRef();
  const [stick, setStick] = useState(false);

  const memoizedCallback = useCallback(nav => {
    setStick(!nav[0].isIntersecting);
  }, []);

  const [attach, detach] = useObserver(memoizedCallback, {
    rootMargin: '10px'
  });
  useEffect(() => {
    attach(navRef.current.parentElement);
    return () => {
      if (navRef.current) {
        detach(navRef.current.parentElement);
      }
    };
  }, []);

  return (
    <div
      styleName={classnames('wrapper', {
        stick
      })}
    >
      <nav
        styleName={classnames('cta-navigation', {
          stick
        })}
        ref={navRef}
      >
        <Section padding=".5rem 0" id="01">
          <GridContainer>
            <Grid direction="x" primaryAlignment="align-center">
              <Cell
                contentAlignment="align-children-middle"
                largeSize="6"
                mediumSize="6"
              >
                <Header level={4} displayAs={5} weight={600}>
                  {name}
                </Header>
              </Cell>
              <Cell
                contentAlignment="align-children-middle"
                largeSize="18"
                mediumSize="18"
              >
                <div styleName="cta">{children}</div>
              </Cell>
            </Grid>
          </GridContainer>
        </Section>
      </nav>
    </div>
  );
};

export default CtaStickyNav;
